import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { useRef, useState } from "react";

const INTRO_VIDEO = `${process.env.REACT_APP_BACKEND_URL}/api/media/intro-video`;

export default function IntroVideo() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  return (
    <section data-testid="intro-video-section" className="py-24 px-6 bg-slate-50 relative overflow-hidden">
      <div className="absolute -top-20 -left-20 w-60 h-60 rounded-full bg-navy/3 blur-3xl" />
      <div className="max-w-4xl mx-auto relative">
        <motion.div
          className="text-center mb-10"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
        >
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-crimson/10 text-crimson text-xs font-body font-bold uppercase tracking-[0.2em] mb-6">
            <Play className="w-3.5 h-3.5" />
            Welcome
          </span>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl text-navy mb-4">
            Meet Dominion Parish
          </h2>
          <p className="font-body text-slate-600 text-base max-w-lg mx-auto">
            Watch our introduction and see what we're all about.
          </p>
        </motion.div>

        <motion.div
          className="relative rounded-3xl overflow-hidden shadow-2xl cursor-pointer group"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.7 }}
          onClick={togglePlay}
          data-testid="intro-video-player"
        >
          <video
            ref={videoRef}
            playsInline
            preload="metadata"
            src={INTRO_VIDEO}
            className="w-full aspect-video object-cover bg-navy"
            onEnded={() => setPlaying(false)}
          />
          {!playing && (
            <div className="absolute inset-0 bg-navy/30 flex items-center justify-center group-hover:bg-navy/20 transition-colors">
              <div className="w-20 h-20 rounded-full bg-white/90 flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                <Play className="w-8 h-8 text-navy ml-1" />
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
}
